"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeCircularProgressStyling = function (theme) {
    return (0, react_1.css)({
        color: theme.mvf.palette.text.continueButtonTextColor,
    });
};
exports.default = makeCircularProgressStyling;
//# sourceMappingURL=makeCircularProgressStyling.js.map